import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import customSpinner from './customSpinner/reducers'
import apiLoaderReducer from './apiLoader/reducers'

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    menu,
    settings,
    customSpinner,
    apiLoader: apiLoaderReducer,
  })
